import type { ElementType, ReactNode } from 'react'

import { useReveal } from '@/lib/useReveal'

interface Props {
  children: ReactNode
  /** Stagger index — CSS turns this into `transition-delay: calc(var(--i) * 90ms)`. */
  i?: number
  className?: string
  as?: ElementType
  /** Overrides the default 0.15 / -10% trigger, for elements near the fold. */
  threshold?: number
}

/**
 * Scroll-reveal wrapper. The animation itself is CSS; this only flips `data-in`
 * once, then the observer disconnects.
 */
export function Reveal({ children, i = 0, className = '', as, threshold }: Props) {
  const Tag = (as ?? 'div') as ElementType
  const { ref, inView } = useReveal<HTMLDivElement>(
    threshold === undefined ? {} : { threshold, rootMargin: '0px' },
  )

  return (
    <Tag
      ref={ref}
      data-in={inView}
      className={`reveal ${className}`.trim()}
      style={{ ['--i' as string]: i }}
    >
      {children}
    </Tag>
  )
}
